import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Box, IconButton, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface Props {
  from: number;
  to: number;
  total: number;
  hasPrevPage: boolean;
  hasNextPage: boolean;
  disabled: boolean;
  onPrevPage: () => void;
  onNextPage: () => void;
}

export const SearchResultPagination: React.FC<Props> = ({
  from,
  to,
  total,
  hasPrevPage,
  hasNextPage,
  disabled,
  onPrevPage,
  onNextPage,
}) => {
  const { t } = useTranslation('navigationModule');

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <Typography variant="body2" color="text.secondary">
        {t('changeTenantDialog.searchResultCount', { from, to, total })}
      </Typography>
      <Box>
        <IconButton size="small" title={t('changeTenantDialog.previousPage')} onClick={onPrevPage} disabled={!hasPrevPage || disabled}>
          <ChevronLeftIcon />
        </IconButton>
        <IconButton size="small" title={t('changeTenantDialog.nextPage')} onClick={onNextPage} disabled={!hasNextPage || disabled}>
          <ChevronRightIcon />
        </IconButton>
      </Box>
    </Box>
  );
};
